import { registerModule } from '../../core/module.js';
import { Settings, Users, Devices, Audit } from './Admin.js';
import { Roles } from './Roles.js';

/** Settings, staff, roles and permissions, tills and the activity log. */
export default registerModule({
  id: 'admin',
  order: 70,
  nav: [
    { to: '/settings', labelKey: 'nav.settings', icon: '⚙', group: 'setup', permission: 'settings.view', order: 1, hintKey: 'nav.hintSettings' },
    { to: '/users', labelKey: 'nav.users', icon: '👤', group: 'setup', permission: 'users.view', order: 2, hintKey: 'nav.hintUsers' },
    { to: '/roles', labelKey: 'nav.roles', icon: '🔑', group: 'setup', permission: 'users.view', order: 3, hintKey: 'nav.hintRoles' },
    { to: '/devices', labelKey: 'nav.devices', icon: '🖥', group: 'setup', permission: 'devices.view', order: 4, hintKey: 'nav.hintDevices' },
    { to: '/audit', labelKey: 'nav.audit', icon: '🗂', group: 'setup', permission: 'audit.view', order: 5, hintKey: 'nav.hintAudit' },
  ],
  routes: [
    { path: '/settings', element: <Settings />, permission: 'settings.view', titleKey: 'settings.title' },
    { path: '/users', element: <Users />, permission: 'users.view', titleKey: 'settings.staff' },
    { path: '/roles', element: <Roles />, permission: 'users.view', titleKey: 'roles.title' },
    { path: '/devices', element: <Devices />, permission: 'devices.view', titleKey: 'settings.devices' },
    { path: '/audit', element: <Audit />, permission: 'audit.view', titleKey: 'settings.audit' },
  ],
});
